import styled from 'styled-components';
import { lighten } from 'library/util/css';

export const styleIcon = (IconComponent, color) => {
  return IconComponent == null ?
    null :
    styled(IconComponent)`
      height: 34px;
      left: 9px;
      position: absolute;
      g {
        g {
          path, rect, polygon {
            fill: ${lighten(color, .2)};
          }
        }
      }
      &&& .secondaryColor {
        fill: ${lighten(color, .2)};
      }
      &&& .tertiaryColor {
        fill: ${lighten(color, .7)};
      }
    `;
};

